<script>
  import { ColorPicker } from 'element-ui'
  export default {
    name:'ElColorPicker',
    extends:ColorPicker
  }
</script>
